/**
 * R24 · Produktanfrage-Fenster (Quick-View und PDP, window.R24Inq)
 *
 * Ausgelagert aus snippets/r24-qv-inquiry.liquid (perf/pdp-weight, 23.09.2026): vorher inline und
 * parserblockierend in jeder Seite, jetzt gecacht und `defer` (laeuft nach dem
 * Parsen, vor DOMContentLoaded). Kein Liquid in dieser Datei.
 */
(function () {
  var TO = 'Kontakt', DOM = 'royal-markt.de';
  function q(root, sel) { return (root || document).querySelector(sel); }
  function abs(u) { try { return new URL(u, location.href).href; } catch (e) { return u || ''; } }
  function esc(s) { return (s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function readQV() {
    var box = q(document, '.mfp-content .t4s-product__info-container') || q(document, '#t4s-quick-view .t4s-product__info-container');
    if (!box) return null;
    var a = q(box, '.t4s-product__title a[href*="/products/"]') || q(box, 'a[href*="/products/"]');
    var url = a ? abs((a.getAttribute('href') || '').split('#')[0].split('?')[0]) : '';
    var title = ((a ? a.textContent : (q(box, '.t4s-product__title') || {}).textContent) || '').replace(/\s*\((?:Kopie|Copy)\)\s*$/i, '').trim();
    var priceEl = q(box, '.t4s-product-price');
    var pm = priceEl ? (priceEl.textContent || '').match(/[\d.][\d.,]*\s*€|€\s*[\d.,]+/) : null;
    var price = pm ? pm[0].trim() : '';
    var skuEl = q(box, '#sku'); var sku = skuEl ? (skuEl.textContent || '').trim() : '';
    var mImg = q(document, '.mfp-content .t4s-product__media-wrapper img') || q(document, '.mfp-content img[src*="/cdn/"]') || q(document, '.mfp-content img[data-src*="/cdn/"]');
    var img = mImg ? abs(mImg.currentSrc || mImg.getAttribute('src') || mImg.getAttribute('data-src') || '') : '';
    if (!url && !title) return null;
    return { url: url, title: title, price: price, sku: sku, img: img };
  }

  function openModal(d) {
    if (document.querySelector('.r24-qvm')) return;
    var next = (d.url || location.href) + '?inquiry_sent=1';
    var metaTxt = (d.sku ? 'SKU ' + d.sku + (d.price ? ' · ' : '') : '') + (d.price || '');
    var m = document.createElement('div');
    m.className = 'r24-qvm';
    m.innerHTML =
      '<div class="r24-qvm__ov" data-close></div>' +
      '<div class="r24-qvm__panel" role="dialog" aria-modal="true" aria-label="Anfrage zu diesem Produkt">' +
        '<button type="button" class="r24-qvm__x" data-close aria-label="Schließen">&times;</button>' +
        '<div class="r24-qvm__head">' +
          (d.img ? '<img class="r24-qvm__img" src="' + esc(d.img) + '" alt="">' : '') +
          '<div class="r24-qvm__htx">' +
            '<span class="r24-qvm__ey"><i class="las la-comment-dots" aria-hidden="true"></i> Produktanfrage</span>' +
            '<span class="r24-qvm__pt">' + esc(d.title) + '</span>' +
            (metaTxt ? '<span class="r24-qvm__meta">' + esc(metaTxt) + '</span>' : '') +
          '</div>' +
        '</div>' +
        '<form class="r24-qvm__form" method="POST" enctype="multipart/form-data">' +
          '<input type="hidden" name="_subject" value="' + esc('🛋️ Produktanfrage: ' + d.title) + '">' +
          '<input type="hidden" name="_template" value="table">' +
          '<input type="hidden" name="_captcha" value="false">' +
          '<input type="hidden" name="_next" value="' + esc(next) + '">' +
          '<input type="hidden" name="_autoresponse" value="' + esc('Vielen Dank für Ihre Anfrage zu „' + d.title + '"! Wir haben Ihre Nachricht erhalten und melden uns schnellstmöglich bei Ihnen. Ihr ROYAL24-Team.') + '">' +
          '<input type="text" name="_honey" class="r24-qvm__hide" tabindex="-1" autocomplete="off" aria-hidden="true">' +
          '<input type="hidden" name="📩 Anfrage-Typ" value="Produktanfrage (Quick-View)">' +
          '<input type="hidden" name="🛋️ Produkt" value="' + esc(d.title) + '">' +
          '<input type="hidden" name="🔗 Produktlink" value="' + esc(d.url) + '">' +
          (d.img ? '<input type="hidden" name="🖼️ Produktbild" value="' + esc(d.img) + '">' : '') +
          (d.sku ? '<input type="hidden" name="🔖 SKU" value="' + esc(d.sku) + '">' : '') +
          (d.price ? '<input type="hidden" name="💶 Preis" value="' + esc(d.price) + '">' : '') +
          '<input type="file" name="Produktbild-Datei" class="r24-qvm__hide" tabindex="-1" aria-hidden="true">' +
          '<div class="r24-qvm__row">' +
            '<label class="r24-qvm__f"><span>Name</span><input type="text" name="name" autocomplete="name" required></label>' +
            '<label class="r24-qvm__f"><span>E-Mail</span><input type="email" name="email" autocomplete="email" required></label>' +
          '</div>' +
          '<label class="r24-qvm__f"><span>Telefon <em>(optional)</em></span><input type="tel" name="📞 Telefon" autocomplete="tel"></label>' +
          '<label class="r24-qvm__f"><span>Ihre Frage</span><textarea name="💬 Nachricht" rows="4" required>' + esc('Ich interessiere mich für „' + d.title + '" und habe folgende Frage: ') + '</textarea></label>' +
          '<button type="submit" class="r24-qvm__submit"><i class="las la-paper-plane" aria-hidden="true"></i> Anfrage senden</button>' +
          '<p class="r24-qvm__note">Ihre Angaben nutzen wir ausschließlich zur Beantwortung Ihrer Anfrage.</p>' +
        '</form>' +
      '</div>';
    document.body.appendChild(m);
    document.documentElement.style.overflow = 'hidden';
    var form = m.querySelector('form');
    form.setAttribute('action', 'https://formsubmit.co/' + TO + String.fromCharCode(64) + DOM);
    function close() { m.remove(); document.documentElement.style.overflow = ''; document.removeEventListener('keydown', onKey); }
    function onKey(e) { if (e.key === 'Escape') close(); }
    m.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) close(); });
    document.addEventListener('keydown', onKey);
    form.addEventListener('submit', function (e) {
      if (form.__s) return;
      var fi = form.querySelector('input[type="file"]');
      if (!fi || !d.img || !window.fetch || typeof DataTransfer === 'undefined') return;
      e.preventDefault();
      /* Zeitgeber UND Bildabruf rufen go(); form.submit() feuert kein submit → Sperre hier. */
      var go = function () { if (form.__s) return; form.__s = 1; form.submit(); };
      var to = setTimeout(go, 2500);
      fetch(d.img).then(function (r) { return r.ok ? r.blob() : null; }).then(function (b) {
        clearTimeout(to);
        if (b && b.size) { try { var f = new File([b], 'produkt.jpg', { type: b.type || 'image/jpeg' }); var dt = new DataTransfer(); dt.items.add(f); fi.files = dt.files; } catch (e2) {} }
        go();
      }).catch(function () { clearTimeout(to); go(); });
    });
    setTimeout(function () { try { m.querySelector('input[name="name"]').focus(); } catch (e) {} }, 40);
  }

  function injectBtn() {
    var box = q(document, '.mfp-content .t4s-product__info-container') || q(document, '#t4s-quick-view .t4s-product__info-container');
    if (!box || box.getAttribute('data-r24-qv-inq')) return;
    var btns = q(box, '.t4s-product-form__buttons');
    if (!btns) return;
    box.setAttribute('data-r24-qv-inq', '1');
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'r24-qv-inq-btn';
    b.innerHTML = '<i class="las la-comment-dots" aria-hidden="true"></i> Frage zum Produkt';
    b.addEventListener('click', function () { var d = readQV(); if (d) openModal(d); });
    btns.parentNode.insertBefore(b, btns.nextSibling);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('.t4s-pr-quickview, [data-action-quickview]')) {
      [400, 900, 1500].forEach(function (t) { setTimeout(injectBtn, t); });
    }
  });
  /* Öffentliche API: erlaubt der neuen Produktseite (r24-product-main), dasselbe
     Anfrage-Fenster wiederzuverwenden — EINE Modal-/FormSubmit-Quelle, kein Zweitsystem. */
  window.R24Inq = { open: openModal };
})();
